import { useReducer } from 'react';

export function useRerender() {
  // reducer used for triggering a re-render. the state isn't needed and is simply a counter in order
  // to return a "new" state that causes the re-render.
  const [, rerender] = useReducer((x) => x + 1, 0);

  return rerender;
}
